import * as blogs from 'src/api/blogs'
import {
  BLOG_HELPERS,
  SET_BLOG
} from 'src/store/mutation-types'

const getBlogHelpers = ({commit}) => {
  blogs.getBlogHelpers().then(response => {
    commit(BLOG_HELPERS, response)
  })
}

const setBlog = ({commit}, data) => {
  commit(SET_BLOG, data)
}

export default{
  getBlogHelpers,
  setBlog
}



// WEBPACK FOOTER //
// ./src/components/blog/store/actions.js